import { render, staticRenderFns } from "./messageRecordDetail.vue?vue&type=template&id=81db40fa&scoped=true"
import script from "./messageRecordDetail.vue?vue&type=script&lang=js"
export * from "./messageRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./messageRecordDetail.vue?vue&type=style&index=0&id=81db40fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db40fa",
  null
  
)

export default component.exports